var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-news"},[_c('div',{staticClass:"title"},[_vm._v("\n        更多新闻\n    ")]),_vm._v(" "),_c('div',{staticClass:"cont"},_vm._l((_vm.data),function(item,index){return _c('a',{key:index,staticClass:"cont-c",attrs:{"target":"_blank","href":`/news/${item.guid}`}},[_vm._v("\n            "+_vm._s(item.title)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }